import {IDictionary} from "@/shared/models/interface/dictionary-model";
import {IFixedFilter} from "@/shared/models/view/fixed-filter-model";
import {defaultConfig, ISearchSettings} from "../models/search-settings-model";
import {SearchResult} from "../models/search-result-model";
import {PureSearchService} from "../services/pure/search-service";
import {VUSearchService} from "../services/vu/search-service";
import {IFilterService} from "../services/interfaces/filter-service-interface";
import {IFilterItem} from "../models/filter-item-model";

export class State {
    config: ISearchSettings = defaultConfig;
    query!: string;

    searchService!: VUSearchService | PureSearchService;
    filterService!: IFilterService;

    fixedFilters!: IDictionary<IFixedFilter>;
    UserFilterOverride!: IDictionary<IFilterItem[]>;

    isInitialized: boolean = true;
    searchFailed: boolean = false;
    searchLoading: boolean = true;
    initialSearchCallExecuted: boolean = false;

    searchQuery: string = "";
    searchResultLimit: number = 10;
    searchResultSkip: number = 10;
    searchResults: SearchResult[] = [];
    searchResultsCount: number = 0;

    pageNumber: number = 0;

    imageFallback: string = "";
}